import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/distributions/$id/distributions-events/")({
  // Breadcrumbs and bookmarks may hit this bare path; the events list lives on
  // the distribution detail page.
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/distributions/$id", params: { id: params.id } });
  },
});
